import script from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MegaMenu.vue?vue&type=style&index=0&id=add05d18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add05d18"]])

export default __exports__